export default "__VITE_ASSET__ba4f14b8__"